module.exports = __webpack_public_path__ + "static/media/spot12.6f98f05b.webp";